/**
 * Created by rorschach on 2018/1/25.
 */

import React from "react";
import { ActivityIndicator } from "xyui";

class LazyWrapper extends React.Component {
  constructor(props) {
    super(props);
    this.onLoaded = this.onLoaded.bind(this);
    this.state = {
      // short for "module" but that's a keyword in js, so "mod"
      mod: null
    };
  }

  componentWillMount() {
    this.load(this.props);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.load !== this.props.load) {
      this.load(nextProps);
    }
  }

  onLoaded(mod) {
    this.setState({
      // handle both es imports and cjs
      mod: mod.default ? mod.default : mod
    });
  }

  load(props) {
    this.setState({
      mod: null
    });

    // 如果是 bundle-loader?lazy!./pages/PageHome 方式, 是用回调函数
    const _promise = props.load(this.onLoaded);

    if (_promise && _promise.then) {
      // 如果是 ()=>import() 方式, 要用Promise, 而不是callback
      _promise.then(this.onLoaded);
    }
  }

  render() {
    const view = this.props.children(this.state.mod);
    return view;
  }
}

/*
<Bundle load={loadSomething}>
  {(Comp) => (Comp
    ? <Comp/>
    : <Loading/>
  )}
</Bundle>

const About = (props) => (
  <Bundle load={loadAbout}>
    {(About) => <About {...props}/>}
  </Bundle>
)
 */

function createLazy(lazyComponentLoad) {
  return props => (
    <LazyWrapper load={lazyComponentLoad}>
      {Comp =>
        Comp ? (
          <Comp {...props} />
        ) : (
          <ActivityIndicator animating toast text="正在加载" />
        )
      }
    </LazyWrapper>
  );
}

export { LazyWrapper, createLazy };



// WEBPACK FOOTER //
// ./src/router/LazyComponent.js